export class MoneyAmount {
  readonly value: number;

  constructor(value: number) {
    this.value = value;
  }

  static readonly zero = new MoneyAmount(0);

  add(other: MoneyAmount): MoneyAmount {
    return new MoneyAmount(this.value + other.value);
  }

  subtract(other: MoneyAmount): MoneyAmount {
    return new MoneyAmount(this.value - other.value);
  }

  multiply(scalar: number): MoneyAmount {
    return new MoneyAmount(this.value * scalar);
  }

  divide(scalar: number): MoneyAmount {
    return new MoneyAmount(this.value / scalar);
  }

  isPositive(): boolean {
    return this.value > 0;
  }

  isNonNegative(): boolean {
    return this.value >= 0;
  }

  equals(other: MoneyAmount): boolean {
    return Math.abs(this.value - other.value) < 1e-9;
  }

  toString(): string {
    return `${this.value.toFixed(2)} CZK`;
  }
}